<div class="receipt-modal">
  <header class="receipt-modal__header">
    <h2 class="receipt-modal__title" id="receipt-modal-title">
      {{ 'expenses.labels.receipt' | translate }}
    </h2>

    <div class="receipt-modal__actions">
      <!--
        Enlace real, no un `window.open`: así funcionan el clic con el botón
        central y el menú contextual, igual que en el modal de revisión.
      -->
      <a
        class="receipt-modal__open"
        target="_blank"
        rel="noopener"
        [href]="url"
      >
        <tui-icon
          icon="tuiIconExternalLink"
          [style.font-size.rem]="0.875"
        ></tui-icon>
        {{ 'expenses.review_modal.open_pdf' | translate }}
      </a>

      <button
        ngbAutofocus
        type="button"
        class="receipt-modal__close"
        [attr.aria-label]="'expenses.close' | translate"
        (click)="close()"
      >
        <tui-icon icon="tuiIconX" [style.font-size.rem]="1"></tui-icon>
      </button>
    </div>
  </header>

  <div class="receipt-modal__body">
    <img
      *ngIf="!hasError; else receiptError"
      class="receipt-modal__image"
      [src]="url"
      [alt]="'expenses.receipt_attached' | translate"
      (error)="onError()"
    />

    <ng-template #receiptError>
      <p class="receipt-modal__error">
        <tui-icon
          icon="tuiIconAlertCircle"
          [style.font-size.rem]="1.25"
        ></tui-icon>
        <span>{{ 'expenses.review_modal.receipt_error' | translate }}</span>
      </p>
    </ng-template>
  </div>
</div>
